import '../styles/section-title.css'

const SectionTitles = ({children}) => {
  return (
    <div className='section-title'>{children}</div>
  )
}

export default SectionTitles